module.exports = __webpack_public_path__ + "static/icons/icon-play-c9dc92972ceea63aee2714f8828fdf1d.svg";